/* amai-override.js: pure JavaScript override for Amai Upsell customer ID via globalOnLoad hook */
;(function(){
  var w = window;

  // Override function to apply customer ID override
  function applyOverride() {
    // Ensure all Amai objects exist
    w.Spurit = w.Spurit || {};
    w.Spurit.QuantityBreaks2 = w.Spurit.QuantityBreaks2 || {};
    w.Spurit.QuantityBreaks2.snippet = w.Spurit.QuantityBreaks2.snippet || {};
    w.Spurit.QuantityBreaks2.config = w.Spurit.QuantityBreaks2.config || {};
    w.Spurit.globalSnippet = w.Spurit.globalSnippet || {};

    // Mapping of hostnames to default customer IDs
    var hostToCustomerId = {
      'es.toproset.eu': '22894999339357',
      'nl.toproset.eu': '22903490773341',
      'en.toproset.eu': '22903562273117'
    };

    // Determine host and IDs
    var host = w.location.host.toLowerCase();
    var defaultCustomerId = hostToCustomerId[host] || null;
    var realCustomerId = w.Shopify && Shopify.customer && Shopify.customer.id ? String(Shopify.customer.id) : null;
    var snippetCustomerId = realCustomerId || defaultCustomerId;

    if (!snippetCustomerId) {
      console.log('Amai draft: anonymous checkout (no override)');
      return;
    }

    // Apply override fields
    w.Spurit.QuantityBreaks2.snippet.customer = { id: snippetCustomerId };
    w.Spurit.QuantityBreaks2.snippet.use_customer_default_address = true;
    w.Spurit.globalSnippet.customer_id = snippetCustomerId;

    console.log('✅ Amai override applied. Customer ID:', snippetCustomerId);
  }

  // Hook into Amai init
  if (w.Spurit && typeof w.Spurit.globalOnLoad === 'function') {
    var origGlobalOnLoad = w.Spurit.globalOnLoad;
    w.Spurit.globalOnLoad = function() {
      try { origGlobalOnLoad(); } catch(e) { console.warn('Error in original globalOnLoad:', e); }
      applyOverride();
    };
  } else {
    // Fallback if Amai hasn't defined globalOnLoad yet
    window.addEventListener('load', applyOverride);
  }
})();
